const config = {
    backendUrl: process.env.REACT_APP_BACKEND_URL || 'https://www.sritakshashilagurukul.com', 
  };
  
  export default config;
  